import React from 'react';
import {
  Box,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

const VerificationBadge = () => {
  return (
    <Box 
      component="span" 
      sx={{ 
        display: 'inline-flex',
        alignItems: 'center',
        color: '#00F5FF'
      }}
    >
      <VerifiedIcon sx={{ fontSize: 20 }} />
    </Box>
  );
};

export default VerificationBadge;
